// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import initCountdown from './js/widgets/numericCountdown.js';
import mainSlider from './js/widgets/mainSlider.js';
import cardsGallery from './js/widgets/cardsGallery.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import cardWidget7 from './js/widgets/cardsWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import managedSponsors from './js/widgets/managedSponsors.js';
import sponsors from './js/widgets/sponsors.js';
import footerNavigation from './js/widgets/footerNavigation.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
  if (globalThis.location.pathname === '/') {
    initCountdown();
    mainSlider();
    cardsGallery('sliderCards', sliderCardsOpts, 2);
    seoWidget();
    cardWidget7();
    eventsWidget();
    $(globalThis).on('load', function () {
      videoWidget();
    });
    managedSponsors();
    sponsors();
  }
  footerNavigation();
  cardsGallery('footerCards', footerCardsOpts, 4);
});
